import {forwardRef} from 'react';
import useTranslation from 'next-translate/useTranslation';

import careAvif from '@/assets/images/home/caseStudies/care.avif';
import carePng from '@/assets/images/home/caseStudies/care.png';
import careWebp from '@/assets/images/home/caseStudies/care.webp';
import sanFranGiantsAvif from '@/assets/images/home/caseStudies/giants.avif';
import sanFranGiantsPng from '@/assets/images/home/caseStudies/giants.png';
import sanFranGiantsWebp from '@/assets/images/home/caseStudies/giants.webp';
import riceUniversityAvif from '@/assets/images/home/caseStudies/rice.avif';
import riceUniversityPng from '@/assets/images/home/caseStudies/rice.png';
import riceUniversityWebp from '@/assets/images/home/caseStudies/rice.webp';
import thalesAvif from '@/assets/images/home/caseStudies/thales.avif';
import thalesPng from '@/assets/images/home/caseStudies/thales.png';
import thalesWebp from '@/assets/images/home/caseStudies/thales.webp';
import CaseStudiesCard, {CaseStudyCase} from './CaseStudiesCard';

const CASE_STUDY_CASES: Record<string, CaseStudyCase> = {
  CARE: {
    title: 'Care.com',
    description: 'Increased onsite attendance by 3x',
    imageAvif: careAvif,
    imagePng: carePng,
    imageWebp: careWebp,
    imageAlt: 'boxes of donuts',
    link: 'https://www.ezcater.com/company/corporate-case-study/care-case-study',
  },
  SAN_FRANCISCO_GIANTS: {
    title: 'San Francisco Giants',
    description: 'Saved time and streamlined ordering',
    imageAvif: sanFranGiantsAvif,
    imagePng: sanFranGiantsPng,
    imageWebp: sanFranGiantsWebp,
    imageAlt: 'box of sandwiches',
    link: 'https://www.ezcater.com/company/corporate-case-study/san-francisco-giants-case-study',
  },
  THALES: {
    title: 'Thales',
    description: 'Feeding 900+ employees across multiple locations',
    imageAvif: thalesAvif,
    imagePng: thalesPng,
    imageWebp: thalesWebp,
    imageAlt: 'breakfast sandwiches',
    link: 'https://www.ezcater.com/company/corporate-case-study/thales-case-study',
  },
  RICE_UNIVERSITY: {
    title: 'Rice University',
    description: 'Serving 1,200 students for 40 student-run orgs',
    imageAvif: riceUniversityAvif,
    imagePng: riceUniversityPng,
    imageWebp: riceUniversityWebp,
    imageAlt: 'box of muffins',
    link: 'https://www.ezcater.com/company/corporate-case-study/rice-university-case-study',
  },
};

const CaseStudies = forwardRef<HTMLElement, unknown>(function CaseStudies(_props, ref) {
  const {t} = useTranslation('home');

  return (
    <section ref={ref} className="pt-8">
      <div className="xl:mx-auto">
        <h2 className="mb-6 ml-12 text-[32px] font-bold leading-[38px] xl:ml-0 xl:text-center">
          {t('caseStudies.title')}
        </h2>
        <div className="flex flex-nowrap justify-start gap-6 overflow-x-auto px-6 pb-4 [-ms-overflow-style:none] [scrollbar-width:none] xl:justify-center xl:px-6 [&::-webkit-scrollbar]:hidden">
          {Object.values(CASE_STUDY_CASES).map(caseStudy => (
            <CaseStudiesCard key={caseStudy.title} case={caseStudy} />
          ))}
        </div>
      </div>
    </section>
  );
});

export default CaseStudies;
